<div class="page-header"><h1 class="page-title">Masking</h1></div>
<nz-tabset [nzTabPosition]="'top'" nzType="card" nzSize="small" *ngIf="allProperties" [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="selectedTabIndex = $event">
	<nz-tab [nzTitle]="'Editor'" class="m-0">
		<table class="table">
			<tbody>
				<tr class="table-dark">
					<td>SIM Properties</td>
					<td>&nbsp;</td>
				</tr>
				<tr *ngFor="let property of simProperties; trackBy: trackByHashCode">
					<td>{{property.maskingProperty}}</td>
					<td>
						<select [name]="'property' + property.id" [name]="'property' + property.id" [(ngModel)]="property.maskingType" class="form-control">
							<option [ngValue]="'MaskAll'">Total</option>
							<option [ngValue]="'MaskLeading'">First 4</option>
							<option [ngValue]="'MaskTrailing'">Last 4</option>
							<option [ngValue]="'MaskLeadingAndTrailing'">Sides</option>
							<option [ngValue]="'MaskMiddle'">Center</option>
							<option [ngValue]="'MaskNone'">Clear</option>
						</select>
					</td>
				</tr>


				<tr class="table-dark">
					<td>Personal Data Properties</td>
					<td>&nbsp;</td>
				</tr>
				<tr *ngFor="let property of personalDataProperties; trackBy: trackByHashCode">
					<td>{{property.maskingProperty}}</td>
					<td>
						<select [name]="'property' + property.id" [name]="'property' + property.id" [(ngModel)]="property.maskingType" class="form-control">
							<option [ngValue]="'MaskAll'">Total</option>
							<option [ngValue]="'MaskLeading'">First 4</option>
							<option [ngValue]="'MaskTrailing'">Last 4</option>
							<option [ngValue]="'MaskLeadingAndTrailing'">Sides</option>
							<option [ngValue]="'MaskMiddle'">Center</option>
							<option [ngValue]="'MaskNone'">Clear</option>
						</select>
					</td>
				</tr>

				<tr class="table-dark">
					<td>Agent Data Properties</td>
					<td>&nbsp;</td>
				</tr>
				<tr *ngFor="let property of agentDataProperties; trackBy: trackByHashCode">
					<td>{{property.maskingProperty}}</td>
					<td>
						<select [name]="'property' + property.id" [name]="'property' + property.id" [(ngModel)]="property.maskingType" class="form-control">
							<option [ngValue]="'MaskAll'">Total</option>
							<option [ngValue]="'MaskLeading'">First 4</option>
							<option [ngValue]="'MaskTrailing'">Last 4</option>
							<option [ngValue]="'MaskLeadingAndTrailing'">Sides</option>
							<option [ngValue]="'MaskMiddle'">Center</option>
							<option [ngValue]="'MaskNone'">Clear</option>
						</select>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="row">
			<div class="col">
				<button class="btn btn-primary float-end" (click)="doSubmit()">Save</button>
			</div>
		</div>
	</nz-tab>
	<nz-tab [nzTitle]="'Change history'" class="m-0" *hasPermission="['AuditModificationList']">
		<app-audit-timeline *ngIf="selectedTabIndex == 1" [audits]="(modifications! | async)!" [downloadHeading]="'Masking Audit'" [downloadName]="'masking_audit'"></app-audit-timeline>
	</nz-tab>
</nz-tabset>
